'use client';

import { useEffect } from 'react';
import Lenis from 'lenis';

const easeOutExpo = (t: number) => {
  return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
};

export const SmoothScroll = () => {
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isDesktopViewport = window.matchMedia('(min-width: 1024px)').matches;
    const isTouchPointer = window.matchMedia('(pointer: coarse)').matches;

    if (prefersReducedMotion || !isDesktopViewport || isTouchPointer) {
      return;
    }

    const lenis = new Lenis({
      duration: 1.6,
      lerp: 0.06,
      easing: easeOutExpo,
      smoothWheel: true,
      syncTouch: true,
      syncTouchLerp: 0.055,
      wheelMultiplier: 0.82,
      touchMultiplier: 1,
      autoRaf: false,
    });

    let frameId = 0;
    const raf = (time: number) => {
      lenis.raf(time);
      frameId = window.requestAnimationFrame(raf);
    };

    frameId = window.requestAnimationFrame(raf);

    const onAnchorClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      const anchor = target?.closest('a[href^="#"]') as HTMLAnchorElement | null;
      const hash = anchor?.getAttribute('href');

      if (!hash || hash === '#') {
        return;
      }

      const targetElement = document.querySelector<HTMLElement>(hash);
      if (!targetElement) {
        return;
      }

      event.preventDefault();
      lenis.scrollTo(targetElement, {
        offset: -28,
        duration: 1.75,
      });
    };

    document.addEventListener('click', onAnchorClick);

    return () => {
      document.removeEventListener('click', onAnchorClick);
      window.cancelAnimationFrame(frameId);
      lenis.destroy();
    };
  }, []);

  return null;
};
